import { PopupEvent } from '@/services/act/PopupController'
import { BasePopupScript } from './BasePopupScript'

let vueIns = null
export const setVueIns = (_this) => {
  vueIns = _this
}

/**
 * 获取弹出条件方法
 * @returns {Promise<boolean>}
 */
const getValid = async () => {
  try {
    return await vueIns.refWeeklyOpen()
  } catch (error) {
    return false
  }
}

/**
 * ### 终身VIP弹出活动
 *
 * - TODO:
 * - 由于所有的弹出逻辑都在LifelongVipDiscount.vue中实现，加入整个控制器会比较麻烦。
 * - 所以使用getVueIns去获取实例，再通过 refWeeklyOpen 去调用整个弹出条件。
 */
export class LifelongVipDiscount extends BasePopupScript {
  /** 是否为会员 */
  isMember = false

  constructor () {
    super(PopupEvent.lifelongVipDiscountEvent)
  }

  async valid () {
    /** 非会员 */
    if (this.isMember) {
      const changeOpen = await getValid() // true 可以关闭窗口。
      return !changeOpen
    }
    return false
  }

  updateData (route, store) {
    const { isMember, isPdfLifeMember, isPdfMember } = store.getters
    this.isMember = !isMember && !isPdfLifeMember && !isPdfMember
  }

  reset () { }

  setHasShowTag () {
    console.log('setHasShowTag')
  }
}
